module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/225-maldives-e4cbf57046c5589f64a4b6ef10dd98c9.svg";